import { getElements } from '../../element.js'
import { ajaxButton } from '../../ajax.js'

export const init = () => {

  const shortcodes = getElements('tangible-live-webinar-join')

  for (let i = 0; i < shortcodes.length; i++) {

    const webinarId = shortcodes[i].getAttribute('data-id')

    ajaxButton(shortcodes[i], 'tangible_live_join_webinar_user', {
      id: webinarId
    }, data => data.join_url 
      ? location.href = data.join_url 
      : location.reload()
    )

  }
}
